import React, { useState } from 'react'

import { styled } from 'src/ui/theme'
import { HBox } from 'src/ui/layout'
import { Body } from 'src/ui/typography'
import { breakpoints, useDimensions } from 'src/ui/dimensions'
//@ts-expect-error
import image from '../../../../static/images/hero/hr.png'
//@ts-expect-error
import logo1 from '../../../../static/images/hero/logo-1.png'
//@ts-expect-error
import logo2 from '../../../../static/images/hero/logo-2.png'
//@ts-expect-error
import logo3 from '../../../../static/images/hero/logo-3.png'
//@ts-expect-error
import logo4 from '../../../../static/images/hero/logo-4.png'
//@ts-expect-error
import logo5 from '../../../../static/images/hero/logo-5.png'

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.colors.white.primary};
  justify-content: space-between;
  flex-direction: column;
  overflow: hidden;
  padding: 24px 24px 40px 40px;
  text-decoration: none;
  flex-grow: 0;
  flex-shrink: 0;
  gap: 30px;

  @media (max-width: ${breakpoints.mobile}px) {
    padding: 24px 24px 40px 24px;
  }
`

const ColorTop = styled.div`
  background-color: #4f4ff4;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`

const BackgroundImage = styled.div<{ isHover: boolean; isMobile?: boolean }>`
  position: absolute;
  width: 500px;
  height: 500px;
  top: ${({ isMobile }) => (isMobile ? '-150px' : undefined)};
  bottom: ${({ isHover }) => (isHover ? `120px` : '80px')};
  left: calc(50% - 250px);
  transition: bottom 0.5s ease;
`

const Content = styled.div`
  z-index: 2;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  height: 100%;
`

const Image = styled.img`
  position: absolute !important;
  object-fit: contain;
  opacity: 0.2;
  width: 500px;
  height: 500px;
  z-index: 1;
`

const BetweenBox = styled(HBox)`
  transition: 0.5s ease;
`

const StyledHeaderText = styled.span<{ fontSize?: number }>`
  color: #ffffff;
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '72px')};
  font-weight: 600 !important;
  letter-spacing: 2%;
  line-height: 100%;
  font-weight: 500;
  text-align: center;
  white-space: pre-line;
`

const StyledBodyText = styled.p<{ isMobile?: boolean }>`
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.15px;
  text-align: center;
`

const Logos = styled.div<{ overlap?: number }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  & > * {
    margin-right: ${({ overlap }) => `-${overlap || 8}px`};

    &:last-child {
      margin-right: 0;
    }
  }
`

const LogoLink = styled.a`
  display: flex;
  flex-shrink: 0;
`

const Logo = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
`

const LOGOS_LINKS = [
  { src: logo1, href: 'https://ratingruneta.ru/apps/' },
  { src: logo2, href: 'https://workspace.ru/rating/mobile-developers/' },
  { src: logo3, href: 'https://tagline.ru/mobile-developers-rating/' },
  { src: logo4, href: 'https://ruward.ru/award/2024/84487/' },
  {
    src: logo5,
    href:
      'https://drive.google.com/file/d/19ZJyFndjq13dzZcASEcRtzwdBuMIdn4O/view',
  },
]

type TProps = {
  className?: string
  expandable?: boolean
}

export const MainAchievementCard = ({ className }: TProps) => {
  const [isHover, setIsHover] = useState(false)
  const { isMobile } = useDimensions()
  return (
    <Wrapper
      className={className}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <BackgroundImage isHover={isHover} isMobile={isMobile}>
        <Image src={image} />
      </BackgroundImage>
      <ColorTop />
      <Content>
        <StyledHeaderText fontSize={isMobile ? 48 : 72}>№1</StyledHeaderText>
        <StyledHeaderText fontSize={isMobile ? 20 : 32}>
          в разработке и дизайне мобильных приложений
        </StyledHeaderText>
        <StyledBodyText isMobile={isMobile}>
          во всех основных рейтингах России
        </StyledBodyText>
        <Logos overlap={16}>
          {LOGOS_LINKS.map((logo, index) => (
            <LogoLink
              key={index}
              href={logo.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Logo src={logo.src} alt="" />
            </LogoLink>
          ))}
        </Logos>
      </Content>
    </Wrapper>
  )
}
